import {CreateLicenseRoutine, FetchLicensesRoutine} from '../redux-routines';

export const initialState = {
  isFetching: false,
  data: [],
  error: null
};

export const licensesListReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchLicensesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case FetchLicensesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null
      };
    case FetchLicensesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case CreateLicenseRoutine.SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload],
      };
    case CreateLicenseRoutine.FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};
